var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeskConversation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 20,
    viewBox: "0 0 21.5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "desk-conversation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desk-conversation"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.9,4.9a2.33,2.33,0,0,1,2.3-2.3,2.4,2.4,0,0,1,2.3,2.3,2.4,2.4,0,0,1-2.3,2.3A2.33,2.33,0,0,1,15.9,4.9Zm.6,0a1.7,1.7,0,1,0,1.7-1.7A1.58,1.58,0,0,0,16.5,4.9Z",
    transform: "translate(-1.6 -1.1)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4,11.3a3,3,0,0,0-3.2-2.6c-1.8,0-3.2,1.1-3.2,2.6a.3.3,0,0,1-.6,0c0-1.7,1.7-3.2,3.8-3.2S22,9.6,22,11.3a.3.3,0,0,1-.6,0Z",
    transform: "translate(-1.6 -1.1)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.4,13.7a2.33,2.33,0,0,1,2.3-2.3A2.4,2.4,0,0,1,8,13.7,2.24,2.24,0,0,1,5.8,16,2.42,2.42,0,0,1,3.4,13.7Zm.7,0A1.7,1.7,0,1,0,5.8,12,1.58,1.58,0,0,0,4.1,13.7Z",
    transform: "translate(-1.6 -1.1)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,20.1a3,3,0,0,0-3.2-2.6c-1.8,0-3.2,1.1-3.2,2.6a.27.27,0,0,1-.3.3.27.27,0,0,1-.3-.3c0-1.7,1.7-3.2,3.8-3.2s3.8,1.4,3.8,3.2a.3.3,0,0,1-.6,0Z",
    transform: "translate(-1.6 -1.1)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "5.6 10.5 21.1 10.5 21.1 19.6 20.3 19.6 20.2 11.4 5.6 11.3 5.6 10.5",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.9 17 20.4 17 20.4 17 6.9 17",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Capa_116",
    "data-name": "Capa 116"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,8.1l-1.3-.9H9A1.8,1.8,0,0,1,7.3,5.3V3.4A1.66,1.66,0,0,1,9,1.6h3.1a1.68,1.68,0,0,1,1.8,1.8V5.3a1.68,1.68,0,0,1-1.5,1.8v.5a.55.55,0,0,1-.3.5A.64.64,0,0,1,11.5,8.1ZM7.7,3.4V5.3A1.29,1.29,0,0,0,9,6.7h1.3l1.4.9h.1V6.9a.22.22,0,0,1,.2-.2,1.24,1.24,0,0,0,1.3-1.4V3.4A1.29,1.29,0,0,0,12,2H9A1.34,1.34,0,0,0,7.7,3.4Z",
    transform: "translate(-1.6 -1.1)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6,4c-.1,0-.2.2-.2.4s.1.3.2.3h2.2c.1,0,.2-.1.2-.3s0-.4-.2-.4Z",
    transform: "translate(-1.6 -1.1)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.6 -1.1)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskConversation);
export default __webpack_public_path__ + "static/media/desk-conversation.5fa36309c42deccb34dc11a26f96f1f7.svg";
export { ForwardRef as ReactComponent };